import Message from './Message';

export default (function (w, d) {
    'use strict';

    function AddToWishlistButton() {
        this.init();
    }

    AddToWishlistButton.prototype.init = function () {
        $(function () {
            $('.add-wish').click(function () {
                var $this = $(this);
                var product_id = $(this).attr('data-product-id');
                var url = $(this).attr('data-action') ? $(this).attr('data-action') : route_add_to_wish;

                $('.wishlist-block').removeClass('move');
                $('.wish-slider-wrapper').remove('#idChild');

                $.post(url, { product_id: product_id }, function(response) {
                    if (response.redirect) {
                        window.location = response.redirect;
                    }
                    if (response.status === 'success') {
                        $('.wishlist').html(response.html);
                        $this.parent().parent().find('.count').text(response.count);

                        $this.find('svg').addClass('active');

                        var $wishSlider = $('.wish-slider');
                        $($wishSlider).slick({
                            infinite: false,
                            speed: 300,
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 2,
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 1,
                                    }
                                }
                            ]
                        });

                        new Message(response.message, 'success');
                    } else {
                        new Message(response.message, 'error');
                        // window.location.href = response.redirect;
                    }
                });
            });
        });
    }

    return AddToWishlistButton;
}(window, document));
